import { Component, OnInit } from '@angular/core';
import { patientSectionModeEnum } from '@modules/patient/models/patient-section-visibility.enum';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { PatientModel } from '@shared/models/rx-models/interfaces/patient-model';
import { merge, Observable } from 'rxjs';
import { map, takeUntil, take } from 'rxjs/operators';
import { PatientFacade } from '../../patient.facade';
import { PatientPopupCommands } from '@modules/patient/services/patient-app-iframe-communication.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'rx-patient',
	templateUrl: './patient.component.html',
	styleUrls: ['./patient.component.scss'],
	providers: [PatientFacade]
})
export class PatientComponent extends BaseDestroyableComponent implements OnInit {
	isReadOnly$: Observable<boolean> = this.facade.isReadOnly$;
	patient$: Observable<PatientModel | null> = this.facade.patient$;
	maxPatientLastNameLength$: Observable<number | undefined> = this.facade.maxPatientLastNameLength$;
	patientAppInlineUrl$: Observable<SafeResourceUrl> = this.facade
		.getInlinePatientAppUrl()
		.pipe(map(url => this.sanitizer.bypassSecurityTrustResourceUrl(url)));
	isPatientInConflict$: Observable<boolean | null> = this.facade.isPatientInConflict$;
	isResizePatientAppDialog$: Observable<boolean | null> = this.facade.isPatientInConflict$;
	patientSectionMode$: Observable<patientSectionModeEnum> = this.facade.patientSectionMode$;
	isEditButtonVisibleForReadOnly$: Observable<boolean> = this.facade.isEditButtonVisibleForReadOnly$;
	isClearButtonVisibleForReadOnly$: Observable<boolean> = this.facade.isClearButtonVisibleForReadOnly$;
	isRxFromReferralDoctorAndUserIsScannigCenter$: Observable<boolean> = this.facade.isRxFromReferralDoctorAndUserIsScannigCenter$;
	isIntuitiveFlow$: Observable<boolean> = this.facade.isIntuitiveFlow$;
	patientSectionVersionEnum = patientSectionModeEnum;
	regulatoryDOBMask$: Observable<string | undefined> = this.facade.regulatoryDOBMask$;
	dateFormat$: Observable<string | undefined> = this.facade.dateFormat$;

	constructor(
		private readonly facade: PatientFacade,
		private readonly sanitizer: DomSanitizer
	) {
		super();
	}

	ngOnInit(): void {
		merge(this.facade.initializePatientAppStreams$, this.facade.patientPopupCommandHandler$)
			.pipe(takeUntil(this.componentAlive$))
			.subscribe();
	}

	editPatient(): void {
		this.facade.patientPopupCommandEmitter$.next(PatientPopupCommands.EditPatient);
	}

	clearPatient(): void {
		this.facade.clearPatient().pipe(take(1), takeUntil(this.componentAlive$)).subscribe();
	}
}
